import React from "react";
import {Col, Modal, Row} from "antd";
import {ModalProps} from "antd/lib/modal";
import PictureViewer from "../product-display/pictureViewer";

interface Props extends ModalProps {
    covering?: any
}

function CoveringDetail(props: Props) {

    const {covering, ...otherProps} = props;

    return (
        <Modal width={1000} footer={null} {...otherProps}>
            {covering && (
                <Row>
                    <Col span={12}>
                        <h1>{covering.name}</h1>
                        <h2>{covering.leatherGrade}</h2>
                        <div>
                            <PictureViewer style={{width: 200}} name={covering.coverPhotoUrl} />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div>
                            <h3>DESCRIPTION</h3>
                            <div>{covering.description}</div>
                        </div>
                        <br/>
                        <div>
                            <h3>TECHNICAL FEATURES</h3>
                            <div>{covering.technicalFeatures}</div>
                        </div>
                        <br/>
                        <div>
                            <h3>CARE INSTRUCTIONS</h3>
                            <div>{covering.careInstructions}</div>
                        </div>
                    </Col>
                </Row>
            )}
        </Modal>
    )
}

export default CoveringDetail;
